import React, { useState } from "react";
import { AppBar, Box, Divider, IconButton, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import { MdPerson } from "react-icons/md";
import { CiLogout } from "react-icons/ci";
import { useSelector } from "react-redux";
import cetimg from "../assets/images/navbar/cet_img.png";
import { cssProperties } from "../utils/commonCssProperties";
import { logoutBackoffice } from "../utils/logout";

export const MOBILE_HEADER_HEIGHT = 56;

const iconButtonSx = {
  height: "40px",
  width: "40px",
  border: `1px solid ${cssProperties?.bordercolor?.secondary}`,
  backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`,
};

// Top app bar for phones, used in place of the sidebar + header: logo and
// title, and a profile button whose menu shows the name, roles and logout.
export default function MobileHeader({ title }) {
  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  const [profileAnchor, setProfileAnchor] = useState(null);

  const name = backofficeTokenDetails?.name?.trim() || "";
  const roles = backofficeTokenDetails?.role?.role;
  const roleText = Array.isArray(roles) ? roles.join(", ") : "";

  return (
    <AppBar
      position="fixed"
      sx={{
        height: `${MOBILE_HEADER_HEIGHT}px`,
        justifyContent: "center",
        boxShadow: "none",
        backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`,
        borderBottom: `1px solid ${cssProperties?.bordercolor?.secondary}`,
        zIndex: 100,
      }}
    >
      <Toolbar
        disableGutters
        sx={{ minHeight: `${MOBILE_HEADER_HEIGHT}px !important`, paddingX: "12px", gap: "8px" }}
      >
        <img style={{ width: "32px", height: "32px", flexShrink: 0 }} src={cetimg} alt="logo" />
        <Typography
          noWrap
          sx={{
            flex: 1,
            minWidth: 0,
            fontSize: 16,
            fontWeight: 600,
            color: `${cssProperties?.fontcolor?.primary}`,
          }}
        >
          {title}
        </Typography>
        <IconButton
          aria-label="Profile"
          onClick={(e) => setProfileAnchor(e.currentTarget)}
          sx={{ ...iconButtonSx, color: `${cssProperties?.color?.primary}` }}
        >
          <MdPerson size={22} />
        </IconButton>
      </Toolbar>

      <Menu
        anchorEl={profileAnchor}
        open={Boolean(profileAnchor)}
        onClose={() => setProfileAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { minWidth: "220px", maxWidth: "calc(100vw - 24px)", borderRadius: "8px" } } }}
      >
        <Box sx={{ paddingX: "16px", paddingY: "8px" }}>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 600,
              color: `${cssProperties?.fontcolor?.tableblack}`,
              wordBreak: "break-word",
            }}
          >
            {name || "User"}
          </Typography>
          {roleText && (
            <Typography
              sx={{ fontSize: 12, fontWeight: 500, color: `${cssProperties?.color?.textsecondary}` }}
            >
              {roleText}
            </Typography>
          )}
        </Box>
        <Divider />
        <MenuItem
          onClick={logoutBackoffice}
          sx={{ gap: "8px", fontSize: 14, color: `${cssProperties?.color?.failure}` }}
        >
          <CiLogout size={18} /> Logout
        </MenuItem>
      </Menu>
    </AppBar>
  );
}
